import React from 'react';

import {InlineNotification} from '@/components/ui/InlineNotification';

import {getAutoDeliveryOnHoldContent} from './autoDeliveryOnHoldService';

const AutoDeliveryOnHoldInfoBox = ({className, children, statusUpdateReason}) => {
    const {title, description} = getAutoDeliveryOnHoldContent(statusUpdateReason);

    if (!title && !description && !children) return;

    return (
        <InlineNotification title={title} body={description} className={className}>
            {children}
        </InlineNotification>
    );
};

export default AutoDeliveryOnHoldInfoBox;
